const user_details = {
    page_title: 'รายละเอียดผู้ใช้',
    back_to_users: 'กลับไปที่การจัดการผู้ใช้',
    created_title: 'สร้างผู้ใช้นี้เรียบร้อยแล้ว',
    created_guide: 'นี่คือข้อมูลเพื่อช่วยผู้ใช้ในกระบวนการลงชื่อเข้าใช้',
    created_email: 'อีเมล:',
    created_phone: 'เบอร์โทรศัพท์:',
    created_username: 'ชื่อผู้ใช้:',
    created_password: 'รหัสผ่าน:',
    menu_delete: 'ลบ',
    delete_description: 'การดำเนินการนี้ไม่สามารถย้อนกลับได้ จะเป็นการลบผู้ใช้นี้อย่างถาวร',
    deleted: 'ลบผู้ใช้นี้เรียบร้อยแล้ว',
    reset_password: {
        reset_title: 'คุณแน่ใจหรือว่าต้องการรีเซ็ตรหัสผ่าน?',
        generate_title: 'คุณแน่ใจหรือว่าต้องการสร้างรหัสผ่าน?',
        content: 'การดำเนินการนี้ไม่สามารถย้อนกลับได้ การดำเนินการนี้จะอัปเดตข้อมูลการลงชื่อเข้าใช้ของผู้ใช้',
        reset_complete: 'รีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
        generate_complete: 'สร้างรหัสผ่านเรียบร้อยแล้ว',
        new_password: 'รหัสผ่านใหม่:',
        password: 'รหัสผ่าน:',
    },
    tab_settings: 'การตั้งค่า',
    tab_roles: 'บทบาท',
    tab_logs: 'บันทึกผู้ใช้',
    tab_organizations: 'องค์กร',
    authentication: 'การยืนยันตัวตน',
    authentication_description: 'ผู้ใช้แต่ละรายจะมีโปรไฟล์ที่มีข้อมูลทั้งหมดของผู้ใช้ ประกอบด้วยข้อมูลพื้นฐาน อัตลักษณ์โซเชียล และข้อมูลกำหนดเอง',
    user_profile: 'ข้อมูลผู้ใช้',
    field_email: 'อีเมล',
    field_phone: 'เบอร์โทรศัพท์',
    field_username: 'ชื่อผู้ใช้',
    field_password: 'รหัสผ่าน',
    field_name: 'ชื่อ',
    field_avatar: 'URL รูปประจำตัว',
    field_avatar_placeholder: 'https://your.cdn.domain/avatar.png',
    field_custom_data: 'ข้อมูลกำหนดเอง',
    field_custom_data_tip: 'ข้อมูลผู้ใช้เพิ่มเติมที่ไม่ได้ระบุไว้ในคุณสมบัติของผู้ใช้ที่ตั้งไว้ล่วงหน้า เช่น สีที่ผู้ใช้ชอบและภาษา',
    field_profile: 'โปรไฟล์',
    field_profile_tip: 'ข้อเรียกร้องมาตรฐาน OpenID Connect เพิ่มเติมที่ไม่มีในคุณสมบัติของผู้ใช้ โปรดทราบว่าคุณสมบัติที่ไม่รู้จักทั้งหมดจะถูกตัดออก โปรดดู <a>อ้างอิงคุณสมบัติโปรไฟล์</a> สำหรับข้อมูลเพิ่มเติม',
    field_connectors: 'การเชื่อมต่อโซเชียล',
    field_sso_connectors: 'การเชื่อมต่อองค์กร',
    custom_data_invalid: 'ข้อมูลกำหนดเองต้องเป็นวัตถุ JSON ที่ถูกต้อง',
    profile_invalid: 'โปรไฟล์ต้องเป็นวัตถุ JSON ที่ถูกต้อง',
    password_already_set: 'ตั้งรหัสผ่านแล้ว',
    no_password_set: 'ยังไม่ได้ตั้งรหัสผ่าน',
    connectors: {
        connectors: 'ตัวเชื่อมต่อ',
        user_id: 'รหัสผู้ใช้',
        remove: 'นำออก',
        connected: 'ผู้ใช้นี้เชื่อมต่อกับโซเชียลหลายตัวแล้ว',
        not_connected: 'ผู้ใช้ไม่ได้เชื่อมต่อกับโซเชียลใด ๆ',
        deletion_confirmation: 'คุณกำลังนำอัตลักษณ์ <name/> ที่มีอยู่ออก คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?',
    },
    sso_connectors: {
        connectors: 'ตัวเชื่อมต่อ',
        enterprise_id: 'รหัสองค์กร',
        connected: 'ผู้ใช้นี้เชื่อมต่อกับผู้ให้บริการอัตลักษณ์องค์กรหลายรายสำหรับ Single Sign-On',
        not_connected: 'ผู้ใช้ไม่ได้เชื่อมต่อกับผู้ให้บริการอัตลักษณ์องค์กรสำหรับ Single Sign-On',
    },
    mfa: {
        field_name: 'การยืนยันตัวตนแบบหลายขั้นตอน',
        field_description: 'ผู้ใช้นี้ได้เปิดใช้งานขั้นตอนยืนยันสองขั้น',
        name_column: 'หลายขั้นตอน',
        field_description_empty: 'ผู้ใช้นี้ยังไม่ได้เปิดใช้งานขั้นตอนยืนยันสองขั้น',
        deletion_confirmation: 'คุณกำลังนำ <name/> สำหรับ ขั้นตอนยืนยันสองขั้น ออก คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?',
    },
    passkey: {
        field_name: 'พาสคีย์',
        field_description_empty: 'ผู้ใช้นี้ยังไม่ได้เปิดใช้งานการลงชื่อเข้าใช้ด้วยพาสคีย์',
        deletion_confirmation: 'คุณกำลังนำ <name/> สำหรับการลงชื่อเข้าใช้ด้วยพาสคีย์ ออก คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?',
    },
    suspended: 'ระงับ',
    suspend_user: 'ระงับผู้ใช้',
    suspend_user_reminder: 'คุณแน่ใจหรือว่าต้องการระงับผู้ใช้นี้? ผู้ใช้จะไม่สามารถลงชื่อเข้าใช้แอปของคุณและจะไม่ได้รับ access token ใหม่หลังจากหมดอายุ นอกจากนี้ API ที่ร้องขอโดยผู้ใช้นี้จะล้มเหลว',
    suspend_action: 'ระงับ',
    user_suspended: 'ระงับผู้ใช้แล้ว',
    reactivate_user: 'เปิดใช้งานผู้ใช้อีกครั้ง',
    reactivate_user_reminder: 'คุณแน่ใจหรือว่าต้องการเปิดใช้งานผู้ใช้นี้อีกครั้ง? จะอนุญาตให้ผู้ใช้นี้ลงชื่อเข้าใช้ได้',
    reactivate_action: 'เปิดใช้งานอีกครั้ง',
    user_reactivated: 'เปิดใช้งานผู้ใช้อีกครั้งแล้ว',
    roles: {
        name_column: 'บทบาทผู้ใช้',
        description_column: 'คำอธิบาย',
        assign_button: 'กำหนดบทบาท',
        delete_description: 'การดำเนินการนี้จะลบบทบาทนี้ออกจากผู้ใช้นี้ โดยบทบาทนี้จะยังคงอยู่ แต่จะไม่เชื่อมต่อกับผู้ใช้นี้',
        deleted: '{{name}} ถูกลบออกจากผู้ใช้นี้เรียบร้อยแล้ว',
        assign_title: 'กำหนดบทบาทให้กับ {{name}}',
        assign_subtitle: 'ค้นหาบทบาทที่เหมาะสมโดยค้นหาจากชื่อ คำอธิบาย หรือรหัสบทบาท',
        assign_role_field: 'กำหนดบทบาท',
        role_search_placeholder: 'ค้นหาด้วยชื่อบทบาท',
        added_text: 'เพิ่มแล้ว {{value, number}}',
        assigned_user_count: '{{value, number}} ผู้ใช้',
        confirm_assign: 'กำหนดบทบาท',
        role_assigned: 'กำหนดบทบาทเรียบร้อยแล้ว',
        search: 'ค้นหาโดยชื่อบทบาท คำอธิบาย หรือรหัส',
        empty: 'ไม่มีบทบาท',
    },
    warning_no_sign_in_identifier: 'ผู้ใช้จำเป็นต้องมีตัวระบุสำหรับการลงชื่อเข้าใช้อย่างน้อยหนึ่งรายการ (ชื่อผู้ใช้ อีเมล เบอร์โทรศัพท์ หรือโซเชียล) เพื่อเข้าสู่ระบบ คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?',
    personal_access_tokens: {
        title: 'โทเคนเข้าถึงส่วนตัว',
        title_other: 'โทเคนเข้าถึงส่วนตัว',
        title_short: 'โทเคน',
        empty: 'ผู้ใช้นี้ยังไม่มีโทเคนเข้าถึงส่วนตัว',
        create: 'สร้างโทเคนใหม่',
        tip: 'โทเคนเข้าถึงส่วนตัว (PAT) ช่วยให้ผู้ใช้มอบ access token อย่างปลอดภัยโดยไม่ต้องใช้ข้อมูลเข้าสู่ระบบและการ sign-in แบบโต้ตอบ เหมาะสำหรับ CI/CD, script หรือแอปพลิเคชันที่เข้าถึง resource อัตโนมัติ',
        value: 'ค่า',
        created_at: 'สร้างเมื่อ',
        expires_at: 'หมดอายุเมื่อ',
        never: 'ไม่มีวันหมดอายุ',
        create_new_token: 'สร้างโทเคนใหม่',
        delete_confirmation: 'การดำเนินการนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือว่าต้องการลบโทเคนนี้?',
        expired: 'หมดอายุแล้ว',
        expired_tooltip: 'โทเคนนี้หมดอายุเมื่อ {{date}}',
        create_modal: {
            title: 'สร้างโทเคนเข้าถึงส่วนตัว',
            expiration: 'วันหมดอายุ',
            expiration_description: 'โทเคนจะหมดอายุที่ {{date}}',
            expiration_description_never: 'โทเคนนี้จะไม่มีวันหมดอายุ เราแนะนำให้ตั้งวันหมดอายุเพื่อความปลอดภัยที่ดียิ่งขึ้น',
            days: '{{count}} วัน',
            days_other: '{{count}} วัน',
            created: 'สร้างโทเคน {{name}} เรียบร้อยแล้ว',
        },
        edit_modal: {
            title: 'แก้ไขโทเคนเข้าถึงส่วนตัว',
            edited: 'แก้ไขโทเคน {{name}} เรียบร้อยแล้ว',
        },
    },
    sessions: {
        title: 'เซสชัน',
        description: 'จัดการเซสชันที่ดูแลโดยเซิร์ฟเวอร์การอนุญาต Logto การเพิกถอนเซสชัน Logto ที่นี่จะป้องกันการยินยอมอัตโนมัติในการขอการอนุญาตในอนาคต',
        field_name: 'เซสชัน',
        multiple_signed_in: 'ผู้ใช้นี้ได้ลงชื่อเข้าสู่อุปกรณ์หรือเบราว์เซอร์หลายเครื่อง',
        not_found: 'ไม่พบเซสชัน Logto ที่ใช้งานอยู่ ผู้ใช้ไม่ได้ลงชื่อเข้าใช้ในอุปกรณ์ใด ๆ ในตอนนี้',
        name_column: 'ชื่อ',
        session_id_column: 'รหัสเซสชัน',
        location_column: 'ตำแหน่ง',
        browser_on_os: '{{browser}} บน {{os}}',
        user: 'ผู้ใช้',
        applications: 'แอปพลิเคชัน',
        signed_in_at: 'การลงชื่อเข้าใช้ล่าสุด',
        ip: 'IP',
        browser_name: 'ชื่อเบราว์เซอร์',
        os_name: 'ชื่อระบบปฏิบัติการ',
        device_model: 'รุ่นอุปกรณ์',
        revoke_session: 'เพิกถอนเซสชัน',
        revoke_session_confirmation: 'หากลบเซสชันนี้ ผู้ใช้จะต้องยืนยันตัวตนอีกครั้ง',
    },
    third_party_apps: {
        title: 'แอปของบุคคลที่สาม',
        description: 'ใช้ Logto เป็นผู้ให้บริการตัวตนเพื่ออนุญาตแอปของบุคคลที่สาม ดูและจัดการแอปที่ผู้ใช้นี้เคยให้สิทธิ์เข้าถึงไว้',
        field_name: 'แอปบุคคลที่สามที่ได้รับอนุญาต',
        multiple_authorized: 'ผู้ใช้นี้ได้อนุญาตแอปและบริการของบุคคลที่สามหลายรายการ',
        not_authorized: 'ผู้ใช้นี้ยังไม่ได้อนุญาตแอปหรือบริการของบุคคลที่สาม',
        name_column: 'ชื่อ',
        app_id_column: 'รหัสแอป',
        access_created_at_column: 'ให้สิทธิ์เข้าถึงเมื่อ',
        revoke_access_title: 'เพิกถอนการเข้าถึง?',
        revoke_access_description: 'การดำเนินการนี้จะเพิกถอนสิทธิ์เข้าถึงบัญชีของผู้ใช้นี้จากแอปในทุกอุปกรณ์ ผู้ใช้ต้องอนุญาตใหม่อีกครั้งเพื่อกู้คืนการเข้าถึง',
    },
    connections: {
        title: 'การเชื่อมต่อ',
        description: 'ผู้ใช้เชื่อมบัญชีบุคคลที่สามเพื่อ sign-in โซเชียล SSO องค์กร หรือการเข้าถึง resource',
        token_status_column: 'สถานะโทเคน',
        token_status: {
            active: 'ใช้งาน',
            expired: 'หมดอายุแล้ว',
            inactive: 'ไม่ได้ใช้งาน',
            not_applicable: 'ไม่เกี่ยวข้อง',
            available: 'ใช้งานได้',
            not_available: 'ไม่สามารถใช้งานได้',
        },
    },
};
export default Object.freeze(user_details);
